export enum InteractivityActionTypeValue {
  GoToSlide = 'goToSlide',
  HtmlPopup = 'htmlPopup',
  SlidePopup = 'slidePopup',
  HtmlTooltip = 'htmlTooltip',
  OpenLink = 'openLink',
  Zoom = 'zoom',
  PlayAudio = 'playAudio',
  PlayAnimation = 'playAnimation',
  ControlAnimation = 'controlAnimation',
  PlayStagedAnimations = 'playStagedAnimations',
  ShowElements = 'showElements',
  HideElements = 'hideElements',
  CloseSlidePopup = 'closeSlidePopup',
  Effect = 'effect',
  ScrollToElement = 'scrollToElement',

  Wait = 'wait',
  Sequence = 'sequence',
  Parallel = 'parallel',
  WithTimeout = 'withTimeout',
  Cancel = 'cancel',
  SetVar = 'setVar',
  Conditional = 'conditional',
  WaitUntil = 'waitUntil',

  // if you add a type here, remember to add it to InteractivityAction.ts
}
